import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ProjectsTable from "../../components/Projects/ProjectsTable";




const ProjectsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Projects" />

       {/* Projects Table */}
        <ProjectsTable />   

      </MasterLayout>
    </>
  );
};

export default ProjectsPage;
